import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import { packagePdfStoragePath } from '../../../functions/src/admin/paths';
import type { Language } from '../../api/Lang';
import { useEffect, useState } from 'react';

export async function getPackageMenuPdfUrlOptional(_lang: Language, schoolKey: string, fileName?: string): Promise<string | null> {
    if (!schoolKey || !fileName) return null;
    const path = packagePdfStoragePath(schoolKey, fileName);
    try {
        return await getDownloadURL(ref(getStorage(), path));
    } catch {
        return null;
    }
}

export function usePackageMenuPdfUrl(lang: Language, schoolKey: string, fileName?: string) {
    const [url, setUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        let isMounted = true;
        const fetchUrl = async () => {
            if (!schoolKey || !fileName) {
                if (isMounted) {
                    setUrl(null);
                    setLoading(false);
                }
                return;
            }
            try {
                setLoading(true);
                const downloadUrl = await getPackageMenuPdfUrlOptional(lang, schoolKey, fileName);
                if (isMounted) {
                    setUrl(downloadUrl);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };
        fetchUrl();
        return () => {
            isMounted = false;
        };
    }, [lang, schoolKey, fileName]);

    return { url, loading };
}
